import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slides', 'titleNav', 'Slaidu navigācija');
Labels.set('ui-slides', 'prev', 'Nākamais');
Labels.set('ui-slides', 'next', 'Iepriekšējais');
Labels.set('ui-slides', 'slide', 'Slidkalniņš');
